export enum SvgVariant {
  Black = 'black',
  White = 'white',
  Primary = 'primary',
  Secondary = 'secondary',
  Grey = 'grey',
  Transparent = 'transparent',
  Danger = 'danger'
}
